"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSalesposter = void 0;
var enrich_salesposter_1 = require("./enrich-salesposter");
var insight_params_1 = require("./insight-params");
var structure_response_1 = require("./structure-response");
var zuora_params_1 = require("./zuora-params");
var zuora_to_pulse_origin_1 = require("./zuora-to-pulse-origin");
var zuora_to_search_params_1 = require("./zuora-to-search-params");
function createSalesposter(salesposterResponse, options) {
    var salesposterElem = (0, structure_response_1.structureSalesposterResponse)(salesposterResponse);
    var docRef = options.document.referrer;
    var windowLocationHref = options.window.location.href;
    // r as query-param is used by brands to mark sponsored content. Can probably be deprecated in favor of utm-tags
    var rQuery = new URLSearchParams(options.window.location.search).get('r');
    var query = { r: rQuery || undefined };
    var trackingData = (0, zuora_params_1.zuoraData)({
        contentId: options.contentId,
        contentType: options.contentType,
        docRef: docRef,
        hasSalesLeadBody: options.appendSalesLead,
        paywallType: options.paywallType,
        query: query,
        utmTags: options.utmTagOverrides,
        utmUrlDefault: options.utmUrlDefault,
        windowLocationHref: windowLocationHref,
    }, salesposterElem);
    if (options.includeInsightReferer) {
        var insight = (0, insight_params_1.insightData)({
            contentId: options.contentId,
            contentProvider: options.contentProvider,
            contentType: options.contentType,
            deviceType: options.deviceType,
            hasSalesLeadBody: options.appendSalesLead,
            frontpageVariant: options.frontpageVariant,
            query: query,
            utmTags: options.utmTagOverrides,
            windowLocationHref: windowLocationHref,
        }, salesposterElem, docRef);
        trackingData.referer = insight.tag;
    }
    var searchParams = (0, zuora_to_search_params_1.zuoraToSearchParams)(trackingData, options.additionalParams);
    var returnUrl = options.returnUrl || windowLocationHref.split(/[?#]/)[0].replace(/\/$/, '');
    var enrichedSalesposter = (0, enrich_salesposter_1.enrichSalesposter)({
        searchParams: searchParams,
        returnUrl: returnUrl,
        structuredResponse: salesposterElem,
    });
    var pulseOrigin = (0, zuora_to_pulse_origin_1.zuoraToPulseOrigin)(trackingData);
    return { salesposter: enrichedSalesposter, data: trackingData, pulseOrigin: pulseOrigin };
}
exports.createSalesposter = createSalesposter;
//# sourceMappingURL=create-salesposter.js.map